import React, { useEffect, useState } from "react";
import CommonModal from "../../utils/commonModal";
import Select from "react-select";
import {
  getSendToNetcore,
  postSendToNetCore,
} from "../../../../store/actions/premium/contactUser/contactUser";
import { useDispatch, useSelector } from "react-redux";
import { selectStylesNetcore } from "./selectStylesNetcore";
import { Alert } from "@mui/material";
import { clearPostSendToNetcoreLoading } from "../../../../store/slices/contactPushUser";

const NetcorePopup = ({
  isModalOpen,
  setIsModalOpen,
  showCloseIcon,
  netcoreId,
}) => {
  const dispatch = useDispatch();
  const {
    getSendToNetcoreData,
    getSendToNetcoreLoading,
    sendToNetcoreData,
    sendToNetcoreError,
  } = useSelector((state) => state.contactUser);

  const user = useSelector((state) => state?.userData?.user?.data);

  const [listName, setListName] = useState();
  const [apiKey, setApiKey] = useState();
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowAlert(false);
      dispatch(clearPostSendToNetcoreLoading());
    }, 5000);
  }, [showAlert]);

  useEffect(() => {
    if (sendToNetcoreData?.status == "success") {
      setTimeout(() => {
        setIsModalOpen(false);
      }, 5000);
    }
  }, [sendToNetcoreData]);

  useEffect(() => {
    let netCoreParams = {};
    netCoreParams.id = netcoreId;
    dispatch(getSendToNetcore(netCoreParams));
  }, []);

  function handleCloseModal() {
    setIsModalOpen(false);
  }

  function handleSubmit(e) {
    e.preventDefault();
    let sendToCoreBody = {};
    sendToCoreBody.api_key = apiKey?.key;
    sendToCoreBody.list_name = listName;
    sendToCoreBody.email = user?.email;
    let sendToCoreParams = {};
    sendToCoreParams.id = netcoreId;
    dispatch(postSendToNetCore(sendToCoreBody, sendToCoreParams));
    setListName("");
    setApiKey("");
  }
  return (
    <CommonModal
      isOpen={isModalOpen}
      showCloseIcon={showCloseIcon}
      closeModal={handleCloseModal}
      closeOnOverlayClick={false}
      classNames={{ overlay: "customOverlay", button: "customButton" }}
    >
      <div className="netcore_popup">
        <div className={"new_notification_popup"}>
          {(sendToNetcoreData || sendToNetcoreError) && showAlert && (
            <Alert
              severity={
                sendToNetcoreError || sendToNetcoreData?.status == "error"
                  ? `error`
                  : `success`
              }
            >
              {" "}
              {sendToNetcoreError || sendToNetcoreData?.details}
            </Alert>
          )}
        </div>
        <form onSubmit={(e) => handleSubmit(e)}>
          <h4>Send to Netcore</h4>
          <div className="input_box">
            <span>List Name</span>
            <input
              type="text"
              value={listName}
              onChange={(e) => setListName(e.target.value)}
              required
            />
          </div>
          <div className="input_box">
            <span>API Key</span>
            <Select
              options={getSendToNetcoreData}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.key}
              onChange={(obj) => setApiKey(obj)}
              value={apiKey}
              components={{
                IndicatorSeparator: null,
              }}
              styles={selectStylesNetcore}
              isClearable
            />
          </div>
          <button
            className={`${apiKey && listName ? "" : "pe-none opacity-50"}`}
            type="submit"
            onClick={() => setShowAlert(true)}
          >
            Create
          </button>
        </form>
      </div>
    </CommonModal>
  );
};

export default NetcorePopup;
